import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ActionCards = () => {
  const navigate = useNavigate();

  const actionItems = [
    {
      id: 'new-request',
      title: 'درخواست جدید',
      description: 'ایجاد درخواست جدید برای تهیه سند حقوقی با کمک هوش مصنوعی',
      icon: 'Plus',
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
      buttonText: 'شروع درخواست',
      path: '/new-request-form',
    },
    {
      id: 'view-requests',
      title: 'مشاهده درخواست‌ها',
      description: 'مدیریت و پیگیری وضعیت تمام درخواست‌های ارسالی شما',
      icon: 'FileText',
      color: 'text-green-600',
      bgColor: 'bg-green-50',
      buttonText: 'مشاهده لیست',
      path: '/requests-management',
    },
  ];

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
      {actionItems?.map((item) => (
        <div
          key={item?.id}
          className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-all duration-200 group">
          <div className="flex items-start space-x-4 space-x-reverse mb-4">
            <div
              className={`w-14 h-14 ${item?.bgColor} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-200`}>
              <Icon name={item?.icon} size={28} className={item?.color} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {item?.title}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {item?.description}
              </p>
            </div>
          </div>
          <Button
            variant="outline"
            onClick={() => navigate(item?.path)}
            className="w-full"
            iconName="ArrowLeft"
            iconPosition="left">
            {item?.buttonText}
          </Button>
        </div>
      ))}
    </div>
  );
};

export default ActionCards;
